module.exports = __webpack_public_path__ + "static/media/md-send.dd47517f.svg";